import moment from 'moment';
import { getTranslation } from 'src/utilities/translator';

export const tomorrow = moment().add(24, 'h').toDate();
export const twoWeeks = moment().add(14, 'd').toDate();

export const BANK_OPTIONS = [
  {
    label: 'Mandiri',
    value: '008',
  },
  {
    label: 'BRI',
    value: '002',
  },
  {
    label: 'Permata Bank / Permata Syariah',
    value: '013',
  },
  {
    label: 'CIMB Niaga / CIMB Syariah',
    value: '022',
  },
  {
    label: 'BNI',
    value: '009',
  },
  {
    label: 'BCA',
    value: '014',
  },
  {
    label: 'SMBC',
    value: '213',
  },
];

export const BANKS_WITH_15K_MINIMUM = ['022', '008', '013', '009', '002'];

export const EWALLET_OPTIONS = [
  {
    label: 'ShopeePay',
    value: 'shopeepay_ewallet',
  },
  {
    label: 'LinkAja',
    value: 'linkaja_ewallet',
  },
  {
    label: 'DANA',
    value: 'dana_ewallet',
  },
  {
    label: 'OVO',
    value: 'ovo_ewallet',
  },
];

export const OFFLINE_CHANNEL_OPTIONS = [
  {
    label: 'Indomaret',
    value: 'INDOMARET',
  },
];

export const AMOUNT_TYPE_OPTIONS = [
  {
    label: 'Open Amount',
    value: 'true',
    get description() {
      return getTranslation('common_acceptPaymentUp');
    },
  },
  {
    label: 'Closed Amount',
    value: 'false',
    get description() {
      return getTranslation('virtualAccount_acceptSpecificAmount');
    },
  },
];

export const ADMIN_FEE_OPTIONS = [
  {
    get label() {
      return getTranslation('requestMoney_adminFeeOptions_label');
    },
    value: 'false',
    get description() {
      return [
        getTranslation('common_adminFeeIncludedDesc'),
        getTranslation('paymentLink_qris_alwaysIncludeAdminFee_message2'),
      ];
    },
  },
  {
    get label() {
      return getTranslation('common_excludedFromTotalAmount');
    },
    value: 'true',
    get description() {
      return [getTranslation('common_adminFeeExcludedDesc')];
    },
  },
];

export enum InvoiceCreationFieldName {
  InvoiceNumber = 'invoice_number',
  ListDisabledPaymentMethods = 'list_disabled_payment_methods',
  ListEnabledBanks = 'list_enabled_banks',
  ListEnabledEwallet = 'list_enabled_ewallet',
  ListEnabledOfflineChannel = 'list_enabled_offline_channel',
  IncludeAdminFee = 'include_admin_fee',
  InvoiceDate = 'invoice_date',
  Expiration = 'expiration',
  DueDate = 'due_date',
  PaymentLinkType = 'payment_link_type',
  Attachment = 'attachment',
  Description = 'description',
  CustomerId = 'customer_id',
  Message = 'message',
  DefaultMessage = 'save_as_default_message',
}

export const configurationDefault = {
  is_open: 'true',
  disabled_payment_methods: [],
  is_include_admin_fee: 'false',
  expiration: 24,
  is_lifetime: 'false',
  invoice_message: '',
};

export const INVOICE_SCHEMA_TRANSACTION = {
  DATE: {
    key: 'createdDate',
    label: getTranslation('common_dateAndTime'),
  },
  LAST_UPDATED: {
    key: 'lastUpdated',
    label: getTranslation('common_lastUpdated'),
  },
  PARTNER_TX_ID: {
    key: 'partnerTxId',
    label: getTranslation('common_partnerTxID'),
  },
  PAYMENT_METHOD: {
    key: 'paymentMethod',
    label: getTranslation('common_paymentMethodUsed'),
  },
  EXPIRATION_DATE: {
    key: 'expiredDate',
    label: getTranslation('common_expirationDateTime'),
  },
  STATUS: {
    key: 'status',
    label: getTranslation('common_status'),
  },
};

export const INVOICE_SCHEMA_AMOUNT = {
  AMOUNT_BILLED: {
    key: 'amountBilled',
    label: getTranslation('common_amountBilled'),
  },
  ADMIN_FEE: {
    key: 'adminFee',
    label: getTranslation('common_adminFee'),
  },
  AMOUNT_RECEIVED: {
    key: 'amountReceived',
    label: getTranslation('common_amountReceived'),
  },
};

export const INVOICE_SCHEMA_CUSTOMER = {
  CUSTOMER_NAME: {
    key: 'name',
    label: getTranslation('common_customerName'),
  },
  CUSTOMER_PHONE: {
    key: 'phone',
    label: getTranslation('common_customerPhoneNumber'),
  },
  CUSTOMER_NOTES: {
    key: 'note',
    label: getTranslation('common_customerNotes'),
  },
};

export const TRACK_CUSTOM_COLUM_MAP = {
  transaction: 'untick_transaction_info_custom_column_invoice',
  amount: 'untick_amount_info_custom_column_invoice',
  customer: 'untick_customer_info_custom_column_invoice',
};

export const ADVANCE_SEARCH_KEYS = {
  PARTNER_TRX_ID: 'partner_tx_id',
  TX_REF_NUMBER: 'tx_ref_number',
  CUSTOMER_NAME: 'customer_name',
  PAYMENT_ROUTING_ID: 'payment_routing_id',
  PAYMENT_REF_NUMBER: 'trx_ref_number',
};
